module.exports = __webpack_public_path__ + "img/numero2.5d11d096.svg";